import React from 'react';
import PropTypes from 'prop-types';

import './ResourceTitle.scss';

export default class ResourceTitle extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        text: PropTypes.string.isRequired,
    };

    static defaultProps = {};

    render() {
        const { text } = this.props;
        return (
            <h2 className="component-Employer-Marketing-ResourceTitle">
                {text}
            </h2>
        );
    }
}
